import { render, staticRenderFns } from "./TemplateImagem.vue?vue&type=template&id=5ff8b97c&scoped=true&"
import script from "./TemplateImagem.vue?vue&type=script&lang=js&"
export * from "./TemplateImagem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateImagem.vue?vue&type=style&index=0&id=5ff8b97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8b97c",
  null
  
)

export default component.exports